export default "__VITE_ASSET__DRgD1TqL__"